"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridBodyClassNames: function() {
        return dataGridBodyClassNames;
    },
    useDataGridBodyStyles_unstable: function() {
        return useDataGridBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableBodyStylesstyles = require("../TableBody/useTableBodyStyles.styles");
const dataGridBodyClassNames = {
    root: 'fui-DataGridBody'
};
const useDataGridBodyStyles_unstable = (state)=>{
    'use no memo';
    (0, _useTableBodyStylesstyles.useTableBodyStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridBodyClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useDataGridBodyStyles.styles.js.map
